import React, { useState, useEffect } from "react";
import { Input, Form, Col, Row, Button, Select, Collapse } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "./Helper";

const FirmAccountTableFilter = (props) => {
  const [form] = Form.useForm();

  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });
  const [bankSelect, setBankSelect] = useState({ data: [], loading: false });
  const [currencySelect, setCurrencySelect] = useState({
      data: [],
      loading: false,
    });


  const normalizeTurkish = (text) => {
    return text
      .replace(/ı/g, "i").replace(/I/g, "i")
      .replace(/İ/g, "i").replace(/i/g, "i")
      .replace(/ş/g, "s").replace(/Ş/g, "s")
      .replace(/ğ/g, "g").replace(/Ğ/g, "g")
      .replace(/ü/g, "u").replace(/Ü/g, "u")
      .replace(/ö/g, "o").replace(/Ö/g, "o")
      .replace(/ç/g, "c").replace(/Ç/g, "c");
  };

  const norm = (v) => normalizeTurkish(String(v ?? "")).toLocaleLowerCase("tr-TR");
  const optText = (option) => String(option?.children ?? option?.props?.children ?? "");
  const escapeOdata = (s = "") => String(s).replace(/'/g, "''");

  const containsTr = (field, textRaw) => {
    const text = String(textRaw ?? "").trim();
    if (!text) return "";
    const orig = escapeOdata(text.toLocaleLowerCase("tr-TR"));
    const ascii = escapeOdata(normalizeTurkish(text).toLocaleLowerCase("tr-TR"));
    return `(contains(tolower(${field}), '${orig}') or contains(tolower(${field}), '${ascii}'))`;
  };

  useEffect(() => {
    getBanks();
    getCurrencies();
  }, []);

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const onFirmSeach = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ data: [], loading: true });

      const normalized = normalizeTurkish(value);

      const filter = `
        (
          contains(tolower(name), '${value.toLocaleLowerCase("tr-TR")}')
          or contains(tolower(name), '${normalized}')
          or contains(tolower(firmBranchNumber), '${value.toLocaleLowerCase("tr-TR")}')
          or contains(tolower(firmBranchNumber), '${normalized}')
        ) and Name ne 'Diğer'
      `;

      RequestHandler.get(
        `/Firm?$select=id,firmBranchNumber,name&$filter=${encodeURIComponent(filter)}`
      ).then((res) => {
        setFirmSelect({
          data: [
            { id: `_${value}`, firmBranchNumber: "", name: `'${value}' içerenleri ara` },
            ...res.value
          ],
          loading: false
        });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  const onFinish = (values) => {
    let query = "";
    const conditions = [];

    const addTextSearch = (field, text) => {
      const original = text.toLocaleLowerCase("tr-TR");
      const normalized = normalizeTurkish(text).toLocaleLowerCase("tr-TR");
      return `(contains(tolower(${field}), '${original}') or contains(tolower(${field}), '${normalized}'))`;
    };

    if (values.id) {
      if (values.id.startsWith("_")) {
        const searchValue = values.id.slice(1);
        conditions.push(
          `(${addTextSearch("firmName", searchValue)} or ${addTextSearch("firmBranchNumber", searchValue)})`
        );
      } else {
        conditions.push(`firmId eq ${values.id}`);
      }
    }

    if (values.firmBranchNumber) {
      conditions.push(addTextSearch("firmBranchNumber", values.firmBranchNumber));
    }

    if (values.bankId) {
      conditions.push(`bankId eq ${values.bankId}`);
    }

      if (values.iban) {
      conditions.push(containsTr("iban", values.iban));
    }

    if (values.currencyId) {
      conditions.push(`currencyId eq ${values.currencyId}`);
    }
    
    if(values.accountNumber) {
      conditions.push(containsTr("accountNumber", values.accountNumber));
    }

    if (conditions.length !== 0) {
      query = conditions.join(" and ");
    }
    if (props.onFinishFilter) props.onFinishFilter(query);
  };

  const clearFilter = () => {
    form.resetFields();
    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  const getBanks = () => {
    setBankSelect((s) => ({ ...s, loading: true }));

    RequestHandler.get(`/Bank?$filter=isEmoney ne true&$orderby=name`).then(res => {
       setBankSelect({ data: res.value.filter(x => x.id !== 999), loading: false });
    });
  };

  const getCurrencies = () => {
    setCurrencySelect({
      ...currencySelect,
      loading: true,
    });

    RequestHandler.get(`/Currency?$select=id,code`).then((response) => {
      setCurrencySelect({
        data: response.value,
        loading: false,
      });
    });
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="filter"
              form={form}
              initialValues={{ remember: true }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>

                  
                <Col xs={24} md={12} lg={6} >
                  <Form.Item name="bankId" label="Banka :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      optionFilterProp="children"
                      filterOption={(input, option) => {
                        const needle = norm(input);
                        return norm(optText(option)).includes(needle);
                      }}
                      loading={bankSelect.loading}
                    >
                      {bankSelect.data.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>



                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="id" label={`Cari Adı :`}>
                    <Select
                      allowClear
                      showSearch
                      style={{ width: "100%" }}
                      dropdownStyle={{ minWidth: "50%" }}
                      placeholder="En az 2 harf giriniz.."
                      onSearch={onFirmSeach}
                      filterOption={(input, option) => {
                      const needle = norm(input); 
                      const byText = norm(option?.children); 
                      const byCode = norm(option?.code);     
                      return byText.includes(needle) || byCode.includes(needle);
                      }}
                      loading={firmSelect.loading}
                    >
                      {firmSelect.data.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          code={item.firmBranchNumber}
                        >
                          {`${item.name} ${item.firmBranchNumber ? `(${item.firmBranchNumber})` : ""}`}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item
                    name="firmBranchNumber"
                    label={`Cari Kodu :`}
                  >
                    <Input allowClear />
                  </Form.Item>
                </Col>

              
              <Col xs={24} md={12} lg={6}>
                <Form.Item name="iban" label="Iban :">
                  <Input allowClear />
                </Form.Item>
              </Col>

              <Col xs={24} md={12} lg={6}>
                <Form.Item name="accountNumber" label="Hesap Numarası :">
                  <Input allowClear />
                </Form.Item>
              </Col>

              <Col
                  xs={24}
                  md={12}
                  lg={6}
                >
                  <Form.Item name="currencyId" label="Para Birimi :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      filterOption={(input, option) => norm(optText(option)).includes(norm(input))}
                      loading={currencySelect.loading}
                    >
                      {currencySelect.data.map(({ id, code }) => (
                        <Select.Option key={id} value={`${id}`}>
                          {code}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
           
              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default FirmAccountTableFilter;
